import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import {
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import LoadingResults from './LoadingResults'
import NoResults from './NoResults'
import Results from './Results'
import { search } from '../../services/api/search'
import { setRootMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import './styles.scss'

function useQuery () {
  return new URLSearchParams(useLocation().search)
}

const Search = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const [result, setResult] = useState([])
  const [xhr, setXht] = useState('pending')
  const { page } = useParams()
  const query = useQuery().get('q') || ''

  useIonViewDidEnter(() => {
    setIsVisible(true)
    setRootMetaTags()
    setView(window.location.pathname)
    setPixelView()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  useEffect(() => {
    search({
      q: query,
      offset: (page - 1)
    }).then((response) => {
      const results = response
      results.query = query
      setResult(results)
      setXht('accepted')
    }).catch(() => {
      setResult([])
      setXht('rejected')
    })
    return () => {
      setResult([])
      setXht('pending')
    }
  }, [page, query])

  if (isVisible === false) return null

  if (xhr === 'pending') {
    return <LoadingResults />
  } else if (xhr === 'accepted') {
    return <Results results={result} />
  } else if (xhr === 'rejected') {
    return <NoResults />
  }
}

export default Search
